import posthog from "posthog-js";
import TagManager from "react-gtm-module";

import { currentMetaClickIdentifiers } from "./metaClickIdentifiers";

export const ANALYTICS_EVENTS = {
  // Shared across all surfaces — same names intentionally so PostHog funnels span WP and React
  LAB_EXAM_REQUIREMENT_SHOWN: "lab_exam_requirement_shown",
  LAB_EXAM_REQUIREMENT_ACCEPTED: "lab_exam_requirement_accepted",
  LAB_EXAM_REQUIREMENT_DECLINED: "lab_exam_requirement_declined",
  // React-only
  MEDICATION_CONFIRMED: "medication_confirmed",
  PARENTAL_CONSENT_SHOWN_UNRESOLVABLE_DOB: "parental_consent_shown_unresolvable_dob",
  QUESTIONNAIRE_STEP_VIEW: "questionnaire_step_view",
  QUESTIONNAIRE_STEP_COMPLETE: "questionnaire_step_complete",
} as const;

// Analytics must never block the product flow it's instrumenting — a
// misconfigured GTM/PostHog client (or a blocked script) should not prevent
// the caller's own logic (e.g. page navigation) from proceeding.
export const reportCustomEvent = (event: string, props: Record<string, unknown>): void => {
  try {
    const payload = { ...props, ...currentMetaClickIdentifiers() };
    TagManager.dataLayer({ dataLayer: { event, ...payload } });
    posthog.capture(event, payload);
  } catch (error) {
    console.error(`reportCustomEvent failed for "${event}"`, error);
  }
};
